import FileUploadBody from "../../../../components/form/FileUploadBody";
import ChipTabs from "../../../../components/ChipsTabs";
import { AttachFile, Edit } from "@mui/icons-material";
import EditFiles from "./EditFiles";

export default function FileUploadStep() {
  const content = [<FileUploadBody />, <EditFiles />];
  const titles = ["AttachFiles", "EditFiles"];
  const icons = [<AttachFile />, <Edit />];

  return (
    <ChipTabs
      icons={icons}
      tabContent={content}
      tabLabels={titles}
      lsKey={"file-upload-stepper"}
    />
  );
}
